module.exports = __webpack_public_path__ + "static/media/icon_heart_full_green.3ae67d6d.svg";